// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModal_customerTitle__C9HN1","customerLabel":"ConfirmDeleteModal_customerLabel__t2Tep","customerBtn":"ConfirmDeleteModal_customerBtn__g1QQ9"};